// extracted by mini-css-extract-plugin
export default {"launch_container":"styles_launch_container__v+NsA","launch_name":"styles_launch_name__UTJfc","details":"styles_details__iCGgj"};